import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "p-3 bg-white border border-lightgrey rounded mt-3" }
const _hoisted_4 = { class: "flex flex-col h-full" }
const _hoisted_5 = { class: "flex-1 overflow-auto" }
const _hoisted_6 = { class: "statuscontainer p-2" }
const _hoisted_7 = { class: "formcontainer flex flex-col" }
const _hoisted_8 = { class: "impactLevel" }
const _hoisted_9 = { class: "row flex flex-row w-full" }
const _hoisted_10 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_11 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_12 = { class: "row flex flex-row w-full" }
const _hoisted_13 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_14 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_15 = { class: "row flex flex-row w-full" }
const _hoisted_16 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_17 = { class: "likelihoodlevel mt-3" }
const _hoisted_18 = { class: "row flex flex-row w-full" }
const _hoisted_19 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_20 = { class: "residualrisklevel mt-3" }
const _hoisted_21 = { class: "row flex flex-row w-full" }
const _hoisted_22 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_23 = { class: "buttonposition flex justify-end items-center mt-3 mb-2 mx-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", {
      class: "row w-full justify-between flex",
      style: {"align-items":"center"}
    }, [
      _createElementVNode("h1", { class: "title" }, "Revised Risk")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "ml-2" }, "Revised Impact", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "border-b border-solid mt-3 border-lightgrey" }, null, -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "controllabel" }, "Startegic", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.riskObj.business,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.riskObj.business) = $event)),
                      options: _ctx.dbBussiness,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getMaxImpactValue())),
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "controllabel" }, "Operation", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.riskObj.operations,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.riskObj.operations) = $event)),
                      options: _ctx.dbOperations,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getMaxImpactValue())),
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.riskObj.legal,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.riskObj.legal) = $event)),
                      options: _ctx.dbLegal,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getMaxImpactValue())),
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.riskObj.financial,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.riskObj.financial) = $event)),
                      options: _ctx.dbFinancial,
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getMaxImpactValue())),
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.mainImpact,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mainImpact) = $event)),
                      disabled: "",
                      options: _ctx.dbSeverity,
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getMaxResidualRiskValue())),
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[22] || (_cache[22] = _createElementVNode("h1", { class: "ml-2" }, "Revised Likelihood", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "border-b border-solid mt-3 border-lightgrey" }, null, -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "controllabel" }, "Revised Likelihood", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.riskObj.likelihood,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.riskObj.likelihood) = $event)),
                      options: _ctx.dbLikelihood,
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[25] || (_cache[25] = _createElementVNode("h1", { class: "ml-2" }, "Residual Risk", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "border-b border-solid mt-3 border-lightgrey" }, null, -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel" }, "Security Level", -1)),
                    _createVNode(_component_Select, {
                      modelValue: _ctx.mainResiudalRisk,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mainResiudalRisk) = $event)),
                      options: _ctx.dbSeverity,
                      disabled: "",
                      optionLabel: "key",
                      optionValue: "value",
                      placeholder: "Please select one",
                      class: "custom-multiselect w-full"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-1 mt-3 mb-2" }, null, -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus?'btndisabled pointer-events-none':'btnprimary']),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cancelRisk()))
            }, "Reset", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btnprimary", _ctx.disableStatus?'btndisabled pointer-events-none':'btnprimary']),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mitigateRisk()))
            }, "Mitigate", 2)
          ])
        ])
      ])
    ])
  ]))
}